var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3932_1663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.10377 15.2545C6.42865 15.2571 4.80428 14.6797 3.50664 13.6204C2.20901 12.5611 1.31817 11.0852 0.985471 9.4434C0.652774 7.80165 0.898748 6.09535 1.6816 4.61441C2.46445 3.13348 3.73589 1.96926 5.27989 1.31956C7.04059 0.62409 9.00347 0.64475 10.7491 1.37713C12.4948 2.10951 13.8849 3.49553 14.6223 5.23908C15.3597 6.98262 15.3861 8.94542 14.6957 10.7081C14.0054 12.4709 12.653 13.8937 10.9276 14.6727C10.0351 15.0548 9.07464 15.2527 8.10377 15.2545ZM8.10377 1.88718C4.72647 1.88718 1.98773 4.62591 1.98773 8.00321C1.98773 11.3805 4.72647 14.1193 8.10377 14.1193C11.4811 14.1193 14.2198 11.3663 14.2198 8.00321C14.2198 4.6401 11.4669 1.88718 8.10377 1.88718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44347 11.4371C6.29293 11.4371 6.14855 11.3773 6.0421 11.2708C5.93566 11.1644 5.87585 11.02 5.87585 10.8695V5.46294C5.87585 5.3124 5.93566 5.16802 6.0421 5.06158C6.14855 4.95513 6.29293 4.89532 6.44347 4.89532C6.59401 4.89532 6.73838 4.95513 6.84483 5.06158C6.95128 5.16802 7.01108 5.3124 7.01108 5.46294V10.8695C7.01108 10.944 6.9964 11.0178 6.96787 11.0867C6.93935 11.1555 6.89754 11.2181 6.84483 11.2708C6.79212 11.3235 6.72955 11.3653 6.66068 11.3939C6.59182 11.4224 6.51801 11.4371 6.44347 11.4371ZM9.82077 11.4371C9.67023 11.4371 9.52585 11.3773 9.4194 11.2708C9.31296 11.1644 9.25315 11.02 9.25315 10.8695V5.46294C9.25315 5.3124 9.31296 5.16802 9.4194 5.06158C9.52585 4.95513 9.67023 4.89532 9.82077 4.89532C9.97131 4.89532 10.1157 4.95513 10.2221 5.06158C10.3286 5.16802 10.3884 5.3124 10.3884 5.46294V10.8695C10.3884 10.944 10.3737 11.0178 10.3452 11.0867C10.3166 11.1555 10.2748 11.2181 10.2221 11.2708C10.1694 11.3235 10.1069 11.3653 10.038 11.3939C9.96912 11.4224 9.89531 11.4371 9.82077 11.4371Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3932_1663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0991211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.f6dcb97a228b8623dc511a2b3a13cb83.svg";
export { ForwardRef as ReactComponent };